import React, { useState } from 'react'
import { PhoneForm } from './PhoneForm'
import { useStepper } from 'selfServicePortal/components/Stepper/use-stepper'
import { Stepper } from 'selfServicePortal/components/Stepper/stepper'
import './index.scss'
import { PhoneOtp } from './PhoneOtp'
import { useTranslation } from 'react-i18next'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faChevronLeft } from '@fortawesome/free-solid-svg-icons'
import { Success } from '../Success'

interface PhoneChangeProps {
	onGoBack: () => void
}

export function PhoneChange({ onGoBack }: PhoneChangeProps) {
	const { t } = useTranslation()
	const { stepAmount, activeStep, nextStep, prevStep, isFirstStep } =
		useStepper({
			stepAmount: 3,
			initialStep: 1,
		})
	const [sessionId, setSessionId] = useState<string>()

	return (
		<div className="phone-change">
			<Stepper stepAmount={stepAmount} activeStep={activeStep} />
			<div className="back-button">
				<FontAwesomeIcon icon={faChevronLeft} />
				<button onClick={isFirstStep ? onGoBack : prevStep}>
					{t('Back')}
				</button>
			</div>

			{activeStep === 1 && (
				<PhoneForm
					onSuccess={(sessionId) => {
						setSessionId(sessionId)
						nextStep()
					}}
				/>
			)}
			{activeStep === 2 && (
				<PhoneOtp sessionId={sessionId} onSuccess={nextStep} />
			)}
			{activeStep === 3 && <Success onSuccess={onGoBack} />}
		</div>
	)
}
